var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCrop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6.55228 8 7 8.44772 7 9V16.2C7 16.6446 7.35102 17 7.77778 17H18H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H19V22C19 22.5523 18.5523 23 18 23C17.4477 23 17 22.5523 17 22V19H7.77778C6.24085 19 5 17.7436 5 16.2V9C5 8.44772 5.44772 8 6 8ZM6 1C6.55228 1 7 1.44772 7 2V5H16.2222C17.7591 5 19 6.25636 19 7.8V15C19 15.5523 18.5523 16 18 16C17.4477 16 17 15.5523 17 15V7.8C17 7.35541 16.649 7 16.2222 7H2C1.44772 7 1 6.55228 1 6C1 5.44772 1.44772 5 2 5H5V2C5 1.44772 5.44772 1 6 1Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconCrop.551c74146b2b76daa056b1f2cd59ed74.svg";